"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPageUserInfoWidgetDataSchema = void 0;
/**
 * @deprecated
 * 관련 feature flag: topingMember (member-site)
 */
var zod_1 = require("zod");
var MypageUserInfoSegmentBannerDataSchema = zod_1.z.object({
    button: zod_1.z.object({
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
        title: zod_1.z.string(),
    }),
    imageUrl: zod_1.z.string(),
    subtitle: zod_1.z.string(),
    title: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoUserDataSchema = zod_1.z.object({
    /** 닉네임 */
    nickname: zod_1.z.object({
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
        title: zod_1.z.string(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
    }),
    /** 계정관리 버튼 */
    shortcut: zod_1.z.object({
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
        title: zod_1.z.string(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
    }),
});
var MypageUserInfoMembershipBannerDataSchema = zod_1.z.object({
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    description: zod_1.z.string(),
    iconUrl: zod_1.z.string(),
    memberClassImageUrl: zod_1.z.string().nullable(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoCorporateDataSchema = zod_1.z.object({
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    subtitle: zod_1.z.string(),
    title: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoAssetItemDataSchema = zod_1.z.object({
    data: zod_1.z
        .object({
        action: zod_1.z
            .object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        })
            .nullable(),
        amount: zod_1.z.string().nullable(),
        replacementText: zod_1.z.string().nullable(),
        notice: zod_1.z.string().nullable(),
        tooltip: zod_1.z.string().nullable(),
    })
        .nullable(),
    retry: zod_1.z
        .object({
        api: zod_1.z
            .object({
            method: zod_1.z.string(),
            timeout: zod_1.z.number(),
            url: zod_1.z.string(),
        })
            .optional(),
        title: zod_1.z.string(),
    })
        .nullable(),
    status: zod_1.z.enum(['SUCCESS', 'FAIL']),
    title: zod_1.z.string(),
    type: zod_1.z.enum(['NOL_MONEY', 'NOL_COIN', 'NOL_POINT']),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoAssetReviewCouponDataSchema = zod_1.z.object({
    action: zod_1.z.object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    }),
    retry: zod_1.z
        .object({
        api: zod_1.z
            .object({
            method: zod_1.z.string(),
            timeout: zod_1.z.number(),
            url: zod_1.z.string(),
        })
            .optional(),
        title: zod_1.z.string(),
    })
        .nullable(),
    status: zod_1.z.enum(['SUCCESS', 'FAIL']),
    subtitle: zod_1.z.string().nullable(),
    title: zod_1.z.string(),
    type: zod_1.z.enum(['REVIEW', 'COUPON']),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
var MypageUserInfoAssetDataSchema = zod_1.z.object({
    /** 놀머니, 놀포인트, 놀코인 */
    items: zod_1.z.array(MypageUserInfoAssetItemDataSchema),
    /** 후기, 쿠폰*/
    shortcuts: zod_1.z.array(MypageUserInfoAssetReviewCouponDataSchema),
});
exports.MyPageUserInfoWidgetDataSchema = zod_1.z.object({
    /** 놀머니, 놀포인트, 놀코인 등 자산 및 관련 링크의 정보 */
    asset: MypageUserInfoAssetDataSchema.nullable(),
    /** 기업회원 정보 */
    corporate: MypageUserInfoCorporateDataSchema.nullable(),
    /**
     * 회원등급에 따라 다르게 노출하는 띠배너 정보
     * 골드클래스 배너 정보
     */
    membershipBanner: MypageUserInfoMembershipBannerDataSchema.nullable(),
    /**
     * 특정 집단(예, 비회원)에 노출되는 프로모션 용 배너
     * 비회원용 로그인 유도 위젯
     */
    segmentedBanner: MypageUserInfoSegmentBannerDataSchema.nullable(),
    /**
     * 사용자 상세
     * 회원용 위젯 (비회원 - null)
     */
    user: MypageUserInfoUserDataSchema.nullable(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish().optional(),
});
